export default __webpack_public_path__ + "c34604e92199c8e93c3a6827f60157af.svg";